// extracted by mini-css-extract-plugin
module.exports = {"divider":"DividerSectionElement_divider__f9T3K"};